import { Injectable, ErrorHandler } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
@Injectable({
    providedIn: 'root'
  })
export class ToastService {
    horizontalPosition: MatSnackBarHorizontalPosition = 'end';
    verticalPosition: MatSnackBarVerticalPosition = 'top';
   
    constructor(private _snackBar: MatSnackBar) {

    }

    showError(msg: any, title?: string, duration:number = 1500) {

        var message: string = "Error : ";

        if (typeof msg === "string") {
            message += msg;
        }
        else {

            if (msg.message != undefined) {
                message += msg.message;
            }

            if (msg.error.message != undefined) {
                message += msg.error.message;
            }
        }

        this._snackBar.open(msg, '', {
            duration: duration,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
        });
    }

    showSuccess(msg, title?: string, duration:number = 1500) {
        this._snackBar.open(msg, '', {
            duration: duration,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
        }); 
    }

    showWarning(msg, title?: string, duration:number = 1500) {
        this._snackBar.open(msg, '', {
            duration: duration,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
        });

    }
    showInfo(msg, title?: string, duration:number = 1500) {
        this._snackBar.open(msg, '', {
            duration: duration,
             
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
        });
    }
}